import * as yup from "yup";
import {string} from "yup";
import i18n from 'i18next';

class RequestInvoiceRow{
    constructor({
                    accountingValue = '',
                    product = '',
                    name = '',
                    quantity = 1,
                    price = 0,
                    vatAmount = 0,
                } = {}) {
        this.accountingValue = accountingValue;
        this.product = product;
        this.name = name;
        this.quantity = quantity;
        this.price = price;
        this.vatAmount = vatAmount;
    }

    static getAttributes(filter = null, validationSchema = null ,/* validationSchema2 = null ,*/ optionsData = null) {
        const greaterO = i18n.t('validationMessage.greater0');
        const fieldRequired = i18n.t('validationMessage.fieldRequired');

        const completeSchema = yup.object().shape({
            accountingValue: string().nullable(),
            product: string().required(fieldRequired),
            name: string().nullable(),
            quantity: string().nullable().test('is-positive', `${greaterO}`, value => {
                const numValue = parseFloat(value.replace(',', '.'));
                return !isNaN(numValue) && numValue > 0;
            }),
            price: string().required(fieldRequired).test('is-positive', `${greaterO}`, value => {
                const numValue = parseFloat(value.replace(',', '.'));
                return !isNaN(numValue) && numValue > 0;
            }),
            vatAmount: string().nullable()/*.test('is-positive', `${greaterO}`, value => {
                const numValue = parseFloat(value.replace(',', '.'));
                return !isNaN(numValue) && numValue > 0;
            })*/
        });

        let optionsProduct = [];
        if (optionsData) {
            optionsData.product?.map(item => {
                optionsProduct?.push({
                    label: item.label ?? item.name,
                    value: item.id != null ? String(item.id) : item.name,
                    vatValue: item.vatValue,
                });
            })

        }

        const attributes = {
            accountingValue :{
                // 'label': 'Product',
                'form': {
                    'type': 'text',
                    'placeholder':'AccountingValue',
                    'validation': completeSchema.fields.accountingValue
                },
                'value': (item) => item.accountingValue || "",
            },
            product :{
                // 'label': 'Product',
                'form': {
                    'type': 'select',
                    'placeholder':'Product',
                    'validation': completeSchema.fields.product,
                    'options': optionsProduct,
                },
                'value': (item) => item.product || "",
            },
            name :{
               // 'label': 'Product Name',
                'form': {
                    'type': 'text',
                    'placeholder':'Vara/tjänst',
                    'validation': completeSchema.fields.name,
                },
                'value': (item) => item.name || "",
            },
            quantity :{
               // 'label': 'Quantity',
                'form': {
                    'type': 'number',
                    'placeholder': i18n.t('invoice.enterQuantity'),
                    'validation': completeSchema.fields.quantity,
                },
                'value': (item) => item.quantity || "",
            },
            price :{
               // 'label': 'Price',
                'form': {
                    'type': 'number',
                    'placeholder': i18n.t('formPlaceholder.enterPrice'),
                    'validation': completeSchema.fields.price,
                    'useInternalFormat': true,
                },
                "name": "price",
                'value': (item) => item.price || "",
            },
            vatAmount :{
                //'label': i18n.t('modelLabel.vatAmount'),
                'form': {
                    'type': 'number',
                    'placeholder': i18n.t('formPlaceholder.enterVatAmount'),
                    'validation': completeSchema.fields.vatAmount,
                },
                "name": "vatAmount",
                'value': (item) => item.vatAmount || "",
            },
        }

        if (validationSchema === true) {
            return completeSchema;
        }

        /*if (validationSchema2 === true) {
            return completeSchemaSend;
        }*/

        return attributes;
    }
}
export default RequestInvoiceRow;